"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProvider = void 0;
class Singleton {
    providers = new Map();
    setProvider(name, instance) {
        this.providers.set(name, instance);
        return instance;
    }
    exists(name) {
        return this.providers.has(name);
    }
    getProvider(Provider) {
        if (!this.exists(Provider.name)) {
            throw new Error(`No provider for: ${Provider.name}`);
        }
        return this.providers.get(Provider.name);
    }
}
const singleton = new Singleton();
const provide = (Provider) => singleton.getProvider(Provider);
exports.default = provide;
const createProvider = (Provider) => {
    if (!singleton.exists(Provider.name)) {
        singleton.setProvider(Provider.name, new Provider());
    }
};
exports.createProvider = createProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdmlkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcGFja2FnZXMvY29yZS9wcm92aWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLFNBQVM7SUFDTCxTQUFTLEdBQXlCLElBQUksR0FBRyxFQUFFLENBQUM7SUFFcEQsV0FBVyxDQUFJLElBQVksRUFBRSxRQUFXO1FBQ3RDLElBQUksQ0FBQyxTQUFTLENBQUMsR0FBRyxDQUFDLElBQUksRUFBRSxRQUFRLENBQUMsQ0FBQztRQUNuQyxPQUFPLFFBQVEsQ0FBQztJQUNsQixDQUFDO0lBRUQsTUFBTSxDQUFJLElBQVk7UUFDcEIsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUNsQyxDQUFDO0lBRUQsV0FBVyxDQUFJLFFBQXNCO1FBQ25DLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsRUFBRTtZQUMvQixNQUFNLElBQUksS0FBSyxDQUFDLG9CQUFvQixRQUFRLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQztTQUN0RDtRQUVELE9BQU8sSUFBSSxDQUFDLFNBQVMsQ0FBQyxHQUFHLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBTSxDQUFDO0lBQ2hELENBQUM7Q0FDRjtBQUVELE1BQU0sU0FBUyxHQUFHLElBQUksU0FBUyxFQUFFLENBQUM7QUFFbEMsTUFBTSxPQUFPLEdBQUcsQ0FBSSxRQUFzQixFQUFLLEVBQUUsQ0FDL0MsU0FBUyxDQUFDLFdBQVcsQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUVsQyxrQkFBZSxPQUFPLENBQUM7QUFFaEIsTUFBTSxjQUFjLEdBQUcsQ0FBSSxRQUFzQixFQUFRLEVBQUU7SUFDaEUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxFQUFFO1FBQ3BDLFNBQVMsQ0FBQyxXQUFXLENBQUMsUUFBUSxDQUFDLElBQUksRUFBRSxJQUFJLFFBQVEsRUFBRSxDQUFDLENBQUM7S0FDdEQ7QUFDSCxDQUFDLENBQUM7QUFKVyxRQUFBLGNBQWMsa0JBSXpCIn0=